// Dummy category tree data with parent-child relationships
export const dummyCategoryTree = [
  {
    _id: "cat001",
    name: "Ethnic Wear",
    status: "ACTIVE",
    children: [
      {
        _id: "cat101",
        name: "Salwar Suits",
        status: "ACTIVE",
      },
      {
        _id: "cat102",
        name: "Anarkali Suits",
        status: "ACTIVE",
      },
      {
        _id: "cat103",
        name: "Palazzo Suits",
        status: "ACTIVE",
      },
    ],
  },
  {
    _id: "cat002",
    name: "Wedding Collection",
    status: "ACTIVE",
    children: [
      {
        _id: "cat201",
        name: "Designer Suits",
        status: "ACTIVE",
      },
      {
        _id: "cat202",
        name: "Bridal Suits",
        status: "ACTIVE",
      },
    ],
  },
  {
    _id: "cat003",
    name: "Daily Wear",
    status: "ACTIVE",
    children: [
      {
        _id: "cat301",
        name: "Cotton Suits",
        status: "ACTIVE",
      },
      {
        _id: "cat302",
        name: "Casual Suits",
        status: "ACTIVE",
      },
    ],
  },
  {
    _id: "cat004",
    name: "Party Wear",
    status: "ACTIVE",
    children: [
      {
        _id: "cat401",
        name: "Heavy Work Suits",
        status: "ACTIVE",
      },
      {
        _id: "cat402",
        name: "Patiala Suits",
        status: "ACTIVE",
      },
    ],
  },
  {
    _id: "cat005",
    name: "Fusion Wear",
    status: "ACTIVE",
    children: [
      {
        _id: "cat501",
        name: "Indo-Western",
        status: "ACTIVE",
      },
    ],
  },
  {
    _id: "cat006",
    name: "Office Wear",
    status: "ACTIVE",
    children: [
      {
        _id: "cat601",
        name: "Formal Suits",
        status: "ACTIVE",
      },
    ],
  },
];

// Function to transform categories for display and selection
export function transformCategories(apiCategories) {
  const result = [];

  // Helper function to flatten the category tree
  const flattenCategories = (
    categories,
    parentName = null,
    parentId = null,
  ) => {
    categories?.forEach(category => {
      const displayName = parentName
        ? `${parentName} > ${category.name}`
        : category.name;

      result.push({
        id: category._id,
        name: displayName,
        status: category.status,
        parentId: parentId, // Track parent category ID
      });

      if (category.children && category.children.length > 0) {
        flattenCategories(category.children, displayName, category._id);
      }
    });
  };

  flattenCategories(apiCategories);
  return result;
}

// Dummy data for wholesale salwar suits products
export const dummyProducts = [
  {
    _id: "prod001",
    productId: "SS-001",
    name: "Chikankari Embroidered Salwar Suit",
    brand: { name: "Ethnicwear Collections" },
    size: "Free Size",
    mrp: 2499,
    sellingPrice: 1899,
    quantity: 50,
    soldAs: "Set",
    inStock: true,
    categories: ["cat001", "cat101"],
    primary_category: "cat101",
    material: "Cotton",
    color: "Green",
    description:
      "Traditional Chikankari work Salwar Suit with dupatta. Handcrafted with precision, this elegant piece features intricate white thread embroidery on soft pink cotton fabric. Perfect for summer occasions and festive gatherings.",
    images: ["image1.jpg", "image2.jpg"],
    dateAdded: "2023-01-15",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1899,
          description: "Single salwar suit set with dupatta",
        },
        secondary: {
          name: "Standard Pack",
          description: "Bundle of 6 sets with assorted sizes",
          price: 10794, // 1899 * 6
          items: 6,
        },
        tertiary: {
          name: "Wholesale Carton",
          description: "Complete carton with 4 standard packs",
          price: 43176, // 10794 * 4
          items: 24, // 6 * 4
        },
      },
    },
  },
  {
    _id: "prod002",
    productId: "SS-002",
    name: "Anarkali Style Salwar Suit",
    brand: { name: "Soch" },
    size: "M, L, XL",
    mrp: 3299,
    sellingPrice: 2699,
    quantity: 35,
    soldAs: "Set",
    inStock: true,
    categories: ["cat001", "cat102"],
    primary_category: "cat102",
    material: "Georgette",
    color: "Blue",
    description:
      "Floor length Anarkali suit with heavy embroidery. This stunning royal blue ensemble features gold thread work throughout the bodice and a flowing silhouette that adds grace to every movement. The set includes a matching churidar and dupatta.",
    images: ["image3.jpg", "image4.jpg"],
    dateAdded: "2023-02-10",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 2699,
          description: "Single Anarkali suit with dupatta",
        },
        secondary: {
          name: "Retail Pack",
          description: "Pack of 4 sets with sizes M, L, XL",
          price: 10796, // 2699 * 4
          items: 4,
        },
      },
    },
  },
  {
    _id: "prod003",
    productId: "SS-003",
    name: "Designer Palazzo Suit",
    brand: { name: "W for Woman" },
    size: "S, M, L",
    mrp: 1999,
    sellingPrice: 1499,
    quantity: 0,
    soldAs: "Set",
    inStock: false,
    categories: ["cat001", "cat103"],
    primary_category: "cat103",
    material: "Rayon",
    color: "Mint Green",
    description:
      "Trendy palazzo suit with printed design. This contemporary set features a kurta with modern geometric patterns and solid-colored palazzo pants. The lightweight rayon fabric ensures comfort for everyday wear while maintaining a stylish appearance.",
    images: ["image5.jpg", "image6.jpg"],
    dateAdded: "2023-03-05",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1499,
          description: "Single palazzo suit set",
        },
        secondary: {
          name: "Display Pack",
          description: "Bundle of 3 sets with sizes S, M, L",
          price: 4497, // 1499 * 3
          items: 3,
        },
        tertiary: {
          name: "Store Supply",
          description: "Full range of sizes in multiple colors",
          price: 35976, // 4497 * 8
          items: 24, // 3 * 8
        },
      },
    },
  },
  {
    _id: "prod004",
    productId: "SS-004",
    name: "Straight Cut Embellished Suit",
    brand: { name: "Biba" },
    size: "XS, S, M, L",
    mrp: 2799,
    sellingPrice: 2199,
    quantity: 25,
    soldAs: "Set",
    inStock: true,
    categories: ["cat001", "cat101"],
    primary_category: "cat101",
    material: "Silk Blend",
    color: "Maroon",
    description:
      "Straight cut salwar suit with stone and sequin work. This elegant maroon outfit features delicate handwork on the neckline and sleeves, creating a sophisticated look. Perfect for festive occasions and celebrations, this set includes a matching bottom and dupatta.",
    images: ["image7.jpg", "image8.jpg"],
    dateAdded: "2023-03-22",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 2199,
          description: "Single embellished suit set",
        },
        secondary: {
          name: "Retail Pack",
          description: "Pack of 6 sets with mixed sizes",
          price: 13194, // 2199 * 6
          items: 6,
        },
      },
    },
  },
  {
    _id: "prod005",
    productId: "SS-005",
    name: "Banarasi Jacquard Suit",
    brand: { name: "Fabindia" },
    size: "M, L, XL, XXL",
    mrp: 4999,
    sellingPrice: 3999,
    quantity: 15,
    soldAs: "Set",
    inStock: true,
    categories: ["cat002", "cat201"],
    primary_category: "cat201",
    material: "Banarasi Silk",
    color: "Gold",
    description:
      "Premium Banarasi jacquard suit for special occasions. This luxurious gold outfit showcases traditional weaving techniques with intricate patterns throughout. The rich fabric and classic design make it an ideal choice for weddings and festive ceremonies.",
    images: ["image9.jpg", "image10.jpg"],
    dateAdded: "2023-04-10",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 3999,
          description: "Single Banarasi jacquard suit",
        },
        tertiary: {
          name: "Wedding Collection",
          description: "Exclusive collection for bridal stores",
          price: 47988, // 3999 * 12
          items: 12,
        },
      },
    },
  },
  {
    _id: "prod006",
    productId: "SS-006",
    name: "Printed Cotton Salwar Suit",
    brand: { name: "Global Desi" },
    size: "XS, S, M",
    mrp: 1599,
    sellingPrice: 1299,
    quantity: 40,
    soldAs: "Set",
    inStock: true,
    categories: ["cat003", "cat301"],
    primary_category: "cat301",
    material: "Cotton",
    color: "Yellow",
    description:
      "Comfortable daily wear printed cotton suit. This bright yellow ensemble features cheerful floral prints and a relaxed silhouette, perfect for casual outings and everyday wear. The breathable cotton fabric ensures comfort even in warm weather.",
    images: ["image11.jpg", "image12.jpg"],
    dateAdded: "2023-05-01",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1299,
          description: "Single printed cotton suit",
        },
        secondary: {
          name: "Summer Collection Pack",
          description: "Collection of 8 cotton suits in various prints",
          price: 10392, // 1299 * 8
          items: 8,
        },
      },
    },
  },
  {
    _id: "prod007",
    productId: "SS-007",
    name: "Heavy Work Patiala Suit",
    brand: { name: "Ethnicwear Collections" },
    size: "Free Size",
    mrp: 2899,
    sellingPrice: 2399,
    quantity: 0,
    soldAs: "Set",
    inStock: false,
    categories: ["cat004", "cat402"],
    primary_category: "cat402",
    material: "Crepe",
    color: "Teal",
    description:
      "Punjabi style Patiala suit with heavy embroidery. This traditional teal outfit showcases elaborate thread work and mirror embellishments on the kurta, paired with a classic Patiala salwar and matching dupatta. Perfect for festive celebrations and cultural events.",
    images: ["image13.jpg", "image14.jpg"],
    dateAdded: "2023-05-15",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 2399,
          description: "Single Patiala suit with heavy work",
        },
        secondary: {
          name: "Festival Collection",
          description: "Set of 5 designer Patiala suits",
          price: 11995, // 2399 * 5
          items: 5,
        },
      },
    },
  },
  {
    _id: "prod008",
    productId: "SS-008",
    name: "Sharara Style Suit",
    brand: { name: "Manyavar" },
    size: "S, M, L",
    mrp: 5999,
    sellingPrice: 4899,
    quantity: 10,
    soldAs: "Set",
    inStock: true,
    categories: ["cat002", "cat201"],
    primary_category: "cat201",
    material: "Net",
    color: "Peach",
    description:
      "Designer sharara suit with heavy gota patti work. This elegant peach ensemble features traditional gold embroidery and delicate handwork throughout. The flowing sharara pants and embellished kurta create a regal silhouette, perfect for weddings and special occasions.",
    images: ["image15.jpg", "image16.jpg"],
    dateAdded: "2023-06-02",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 4899,
          description: "Single sharara suit with gota work",
        },
        tertiary: {
          name: "Luxury Collection",
          description: "Premium selection of 10 designer suits",
          price: 48990, // 4899 * 10
          items: 10,
        },
      },
    },
  },
  {
    _id: "prod009",
    productId: "SS-009",
    name: "Casual Wear Cotton Suit",
    brand: { name: "Aurelia" },
    size: "S, M, L, XL",
    mrp: 1299,
    sellingPrice: 999,
    quantity: 60,
    soldAs: "Set",
    inStock: true,
    categories: ["cat003", "cat302"],
    primary_category: "cat302",
    material: "Cotton",
    color: "Light Blue",
    description:
      "Lightweight summer wear cotton suit. This comfortable light blue ensemble features minimal embroidery and a relaxed fit, ideal for everyday wear. The breathable fabric and simple design make it a practical yet stylish choice for casual settings.",
    images: ["image17.jpg", "image18.jpg"],
    dateAdded: "2023-06-20",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 999,
          description: "Single casual cotton suit",
        },
        secondary: {
          name: "Value Pack",
          description: "Pack of 10 casual suits in mixed colors",
          price: 9990, // 999 * 10
          items: 10,
        },
        tertiary: {
          name: "Bulk Order",
          description: "Large wholesale pack for retailers",
          price: 49950, // 999 * 50
          items: 50,
        },
      },
    },
  },
  {
    _id: "prod010",
    productId: "SS-010",
    name: "Designer Lehenga Style Suit",
    brand: { name: "Kalki Fashion" },
    size: "M, L",
    mrp: 7999,
    sellingPrice: 6499,
    quantity: 5,
    soldAs: "Set",
    inStock: true,
    categories: ["cat002", "cat202"],
    primary_category: "cat202",
    material: "Art Silk",
    color: "Red",
    description:
      "Grand lehenga style suit for wedding occasions. This luxurious red ensemble features heavy zari embroidery, sequin work, and elaborate border details. The lehenga-style bottom paired with a designer kurta creates a regal silhouette, perfect for bridal functions and grand celebrations.",
    images: ["image19.jpg", "image20.jpg"],
    dateAdded: "2023-07-05",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 6499,
          description: "Single designer lehenga style suit",
        },
      },
    },
  },
  {
    _id: "prod011",
    productId: "SS-011",
    name: "Dhoti Style Salwar Suit",
    brand: { name: "Soch" },
    size: "S, M, L",
    mrp: 2599,
    sellingPrice: 1999,
    quantity: 20,
    soldAs: "Set",
    inStock: true,
    categories: ["cat005", "cat501"],
    primary_category: "cat501",
    material: "Rayon",
    color: "Mustard",
    description:
      "Modern dhoti style salwar suit for young women. This contemporary mustard ensemble features a fusion design with a stylish kurta and comfortable dhoti-style pants. The trendy silhouette and bold color make it perfect for fashion-forward individuals looking for unique ethnic wear.",
    images: ["image21.jpg", "image22.jpg"],
    dateAdded: "2023-07-18",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1999,
          description: "Single dhoti style suit",
        },
        secondary: {
          name: "Trend Collection",
          description: "Set of 6 contemporary fusion suits",
          price: 11994, // 1999 * 6
          items: 6,
        },
      },
    },
  },
  {
    _id: "prod012",
    productId: "SS-012",
    name: "Digital Printed Salwar Suit",
    brand: { name: "W for Woman" },
    size: "XS, S, M, L, XL",
    mrp: 1899,
    sellingPrice: 1599,
    quantity: 0,
    soldAs: "Set",
    inStock: false,
    categories: ["cat006", "cat601"],
    primary_category: "cat601",
    material: "Polyester Blend",
    color: "Navy Blue",
    description:
      "Digital printed formal salwar suit for office wear. This sophisticated navy blue ensemble features modern geometric prints and a tailored silhouette. The wrinkle-resistant fabric and professional aesthetic make it an ideal choice for workplace environments and business meetings.",
    images: ["image23.jpg", "image24.jpg"],
    dateAdded: "2023-08-01",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1599,
          description: "Single digital printed formal suit",
        },
        secondary: {
          name: "Office Collection",
          description: "Set of 4 formal suits for professional settings",
          price: 6396, // 1599 * 4
          items: 4,
        },
      },
    },
  },
  {
    _id: "prod013",
    productId: "SS-013",
    name: "Embroidered Georgette Gown",
    brand: { name: "Kalki Fashion" },
    size: "S, M, L, XL",
    mrp: 4599,
    sellingPrice: 3899,
    quantity: 12,
    soldAs: "Piece",
    inStock: true,
    categories: ["cat005", "cat501"],
    primary_category: "cat501",
    material: "Georgette",
    color: "Turquoise",
    description:
      "Elegant floor-length georgette gown with intricate embroidery. This stunning turquoise piece features delicate thread work and subtle sequin embellishments throughout the bodice. The flowing silhouette and premium fabric create a graceful look suitable for evening parties and special events.",
    images: ["image25.jpg", "image26.jpg"],
    dateAdded: "2023-08-15",
    sellAsOptions: {
      primaryUnit: "Piece",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Gown",
          price: 3899,
          description: "Single embroidered gown",
        },
        secondary: {
          name: "Boutique Collection",
          description: "Set of 6 designer gowns in assorted colors",
          price: 23394, // 3899 * 6
          items: 6,
        },
      },
    },
  },
  {
    _id: "prod014",
    productId: "SS-014",
    name: "Embellished Kurti with Palazzo",
    brand: { name: "Biba" },
    size: "S, M, L",
    mrp: 2299,
    sellingPrice: 1799,
    quantity: 28,
    soldAs: "Set",
    inStock: true,
    categories: ["cat003", "cat302"],
    primary_category: "cat302",
    material: "Cotton Silk",
    color: "Emerald Green",
    description:
      "Stylish kurti and palazzo set with mirror work and embellishments. This vibrant emerald green ensemble features delicate mirror work on the kurti yoke and a comfortable flared palazzo. The blend of cotton and silk provides both comfort and a subtle sheen, making it perfect for semi-formal occasions.",
    images: ["image27.jpg", "image28.jpg"],
    dateAdded: "2023-09-05",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary", "tertiary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1799,
          description: "Single kurti-palazzo set",
        },
        secondary: {
          name: "Mix & Match Collection",
          description: "Set of 8 kurti-palazzo pairs in complementary colors",
          price: 14392, // 1799 * 8
          items: 8,
        },
        tertiary: {
          name: "Store Display Set",
          description: "Complete range for boutique display",
          price: 43176, // 1799 * 24
          items: 24,
        },
      },
    },
  },
  {
    _id: "prod015",
    productId: "SS-015",
    name: "Handblock Printed Cotton Suit",
    brand: { name: "Fabindia" },
    size: "XS, S, M, L",
    mrp: 1799,
    sellingPrice: 1499,
    quantity: 32,
    soldAs: "Set",
    inStock: true,
    categories: ["cat003", "cat301"],
    primary_category: "cat301",
    material: "Pure Cotton",
    color: "Indigo Blue",
    description:
      "Traditional handblock printed cotton suit with natural dyes. This artisanal indigo blue ensemble features authentic handblock printing using vegetable dyes. Each piece carries unique variations, showcasing the beauty of handcrafted textiles. Perfect for those who appreciate sustainable fashion and traditional crafts.",
    images: ["image29.jpg", "image30.jpg"],
    dateAdded: "2023-09-20",
    sellAsOptions: {
      primaryUnit: "Set",
      selectedConfigurations: ["primary", "secondary"],
      configurations: {
        primary: {
          name: "Individual Set",
          price: 1499,
          description: "Single handblock printed suit",
        },
        secondary: {
          name: "Artisanal Collection",
          description: "Set of 6 handcrafted suits with traditional techniques",
          price: 8994, // 1499 * 6
          items: 6,
        },
      },
    },
  },
];

// Dummy API response format
export const dummyProductsResponse = {
  success: true,
  data: {
    products: dummyProducts,
    totalCount: dummyProducts.length,
    page: 1,
    limit: 10,
    totalPages: Math.ceil(dummyProducts.length / 10),
  },
};

// Mock API response for categories
export const dummyCategoriesResponse = {
  success: true,
  data: {
    categories: dummyCategoryTree,
    totalCount: dummyCategoryTree.length,
  },
};

// Dummy order data
export const dummyOrders = [
  {
    _id: "ord001",
    firmName: "Dream Collection",
    date: "12/07/2023",
    phoneNumber: "7898747967",
    address: "Shop No. 12, Bus Stand Road, Sehore, MP",
    totalAmount: 35000,
    status: "Pending",
    dateCreated: "2023-07-12T08:30:00Z",
    customerName: "Chaitanya Goyal",
    gstin: "78115264569",
  },
  {
    _id: "ord002",
    firmName: "Madhur Creation",
    date: "12/07/2023",
    phoneNumber: "7898747967",
    address: "Shop No. 12, Bus Stand Road, Sehore, MP",
    totalAmount: 35000,
    status: "Approved",
    dateCreated: "2023-07-12T10:15:00Z",
    customerName: "Chaitanya Goyal",
    gstin: "78115264569",
  },
  {
    _id: "ord003",
    firmName: "Paradise Wear",
    date: "12/07/2023",
    phoneNumber: "7898747967",
    address: "Shop No. 12, Bus Stand Road, Sehore, MP",
    totalAmount: 35000,
    status: "Rejected",
    dateCreated: "2023-07-12T14:45:00Z",
  },
  {
    _id: "ord004",
    firmName: "Fashion Store",
    date: "15/07/2023",
    phoneNumber: "9876543210",
    address: "Market Road, Indore, MP",
    totalAmount: 42500,
    status: "Pending",
    dateCreated: "2023-07-15T09:20:00Z",
  },
  {
    _id: "ord005",
    firmName: "Style Hub",
    date: "18/07/2023",
    phoneNumber: "8765432109",
    address: "Main Road, Bhopal, MP",
    totalAmount: 28750,
    status: "Approved",
    dateCreated: "2023-07-18T11:30:00Z",
  },
  {
    _id: "ord006",
    firmName: "Trend Setters",
    date: "20/07/2023",
    phoneNumber: "7654321098",
    address: "MG Road, Jabalpur, MP",
    totalAmount: 55200,
    status: "Rejected",
    dateCreated: "2023-07-20T16:00:00Z",
  },
  {
    _id: "ord007",
    firmName: "Kishan Sales",
    date: "22/07/2023",
    phoneNumber: "9876543211",
    address: "Palasia, Indore, MP",
    totalAmount: 38600,
    status: "Pending",
    dateCreated: "2023-07-22T12:15:00Z",
  },
  {
    _id: "ord008",
    firmName: "Ladies Corner",
    date: "25/07/2023",
    phoneNumber: "8765432108",
    address: "AB Road, Indore, MP",
    totalAmount: 65800,
    status: "Approved",
    dateCreated: "2023-07-25T14:20:00Z",
  },
  {
    _id: "ord009",
    firmName: "Punjab House",
    date: "28/07/2023",
    phoneNumber: "7654321097",
    address: "New Market, Bhopal, MP",
    totalAmount: 24300,
    status: "Rejected",
    dateCreated: "2023-07-28T10:45:00Z",
  },
  {
    _id: "ord010",
    firmName: "Branded Hub",
    date: "01/08/2023",
    phoneNumber: "9876543212",
    address: "Vijay Nagar, Indore, MP",
    totalAmount: 78500,
    status: "Pending",
    dateCreated: "2023-08-01T09:30:00Z",
  },
  {
    _id: "ord011",
    firmName: "Welcome Fashion",
    date: "03/08/2023",
    phoneNumber: "8765432107",
    address: "Malviya Nagar, Bhopal, MP",
    totalAmount: 52000,
    status: "Approved",
    dateCreated: "2023-08-03T16:10:00Z",
  },
  {
    _id: "ord012",
    firmName: "Mandapam",
    date: "05/08/2023",
    phoneNumber: "7654321096",
    address: "Anoop Nagar, Indore, MP",
    totalAmount: 96400,
    status: "Rejected",
    dateCreated: "2023-08-05T13:25:00Z",
  },
  {
    _id: "ord013",
    firmName: "Ethnic Collection",
    date: "08/08/2023",
    phoneNumber: "9876543213",
    address: "LIG Square, Indore, MP",
    totalAmount: 105000,
    status: "Pending",
    dateCreated: "2023-08-08T11:05:00Z",
  },
  {
    _id: "ord014",
    firmName: "Khadi Textiles",
    date: "10/08/2023",
    phoneNumber: "8765432106",
    address: "MP Nagar, Bhopal, MP",
    totalAmount: 45700,
    status: "Approved",
    dateCreated: "2023-08-10T15:45:00Z",
  },
  {
    _id: "ord015",
    firmName: "Samriddhi Fabrics",
    date: "12/08/2023",
    phoneNumber: "7654321095",
    address: "Sapna Sangeeta, Indore, MP",
    totalAmount: 18900,
    status: "Rejected",
    dateCreated: "2023-08-12T10:20:00Z",
  },
  {
    _id: "ord016",
    firmName: "Kishan Sales",
    date: "15/08/2023",
    phoneNumber: "9876543214",
    address: "Scheme 54, Indore, MP",
    totalAmount: 185000,
    status: "Pending",
    dateCreated: "2023-08-15T14:00:00Z",
  },
  {
    _id: "ord017",
    firmName: "Soch Textiles",
    date: "18/08/2023",
    phoneNumber: "8765432105",
    address: "Navlakha, Indore, MP",
    totalAmount: 250000,
    status: "Approved",
    dateCreated: "2023-08-18T12:30:00Z",
  },
  {
    _id: "ord018",
    firmName: "Dream Collection",
    date: "20/08/2023",
    phoneNumber: "7654321094",
    address: "Rajwada, Indore, MP",
    totalAmount: 75800,
    status: "Rejected",
    dateCreated: "2023-08-20T09:15:00Z",
  },
];

// Dummy order response format
export const dummyOrdersResponse = {
  success: true,
  data: {
    orders: dummyOrders,
    totalCount: dummyOrders.length,
    page: 1,
    limit: 10,
    totalPages: Math.ceil(dummyOrders.length / 10),
  },
};

// Dummy vouchers data for autofill and selection
export const dummyVouchers = [
  {
    id: "vchr001",
    code: "FIRST50",
    description: "₹500 off on your first order",
    amount: 500,
    type: "fixed",
    minOrderValue: 0,
    expiryDate: "2023-12-31",
    status: "ACTIVE",
    usageLimit: 1,
    usageCount: 0,
  },
  {
    id: "vchr002",
    code: "SUMMER23",
    description: "₹200 off on orders above ₹2000",
    amount: 200,
    type: "fixed",
    minOrderValue: 2000,
    expiryDate: "2023-09-30",
    status: "ACTIVE",
    usageLimit: 0, // unlimited
    usageCount: 12,
  },
  {
    id: "vchr003",
    code: "FESTIVE10",
    description: "10% off on all items",
    amount: 0,
    percentage: 10,
    type: "percentage",
    maxDiscount: 500,
    minOrderValue: 1000,
    expiryDate: "2023-11-15",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 45,
  },
  {
    id: "vchr004",
    code: "WELCOME25",
    description: "₹250 off on orders above ₹2500",
    amount: 250,
    type: "fixed",
    minOrderValue: 2500,
    expiryDate: "2023-10-31",
    status: "ACTIVE",
    usageLimit: 1,
    usageCount: 0,
  },
  {
    id: "vchr005",
    code: "BULK15",
    description: "15% off on orders above ₹10000",
    amount: 0,
    percentage: 15,
    type: "percentage",
    maxDiscount: 2000,
    minOrderValue: 10000,
    expiryDate: "2023-12-31",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 8,
  },
  {
    id: "vchr006",
    code: "FLAT300",
    description: "Flat ₹300 off on all orders",
    amount: 300,
    type: "fixed",
    minOrderValue: 0,
    expiryDate: "2023-09-15",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 67,
  },
  {
    id: "vchr007",
    code: "SAVE20",
    description: "20% off up to ₹1000",
    amount: 0,
    percentage: 20,
    type: "percentage",
    maxDiscount: 1000,
    minOrderValue: 0,
    expiryDate: "2023-10-31",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 34,
  },
  {
    id: "vchr008",
    code: "NEWUSER",
    description: "₹750 off on your first order above ₹5000",
    amount: 750,
    type: "fixed",
    minOrderValue: 5000,
    expiryDate: "2023-12-31",
    status: "ACTIVE",
    usageLimit: 1,
    usageCount: 0,
  },
  {
    id: "vchr009",
    code: "SPECIAL5",
    description: "5% additional discount on all items",
    amount: 0,
    percentage: 5,
    type: "percentage",
    maxDiscount: 0, // no limit
    minOrderValue: 0,
    expiryDate: "2023-09-30",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 112,
  },
  {
    id: "vchr010",
    code: "FESTIVAL",
    description: "₹1000 off on orders above ₹8000",
    amount: 1000,
    type: "fixed",
    minOrderValue: 8000,
    expiryDate: "2023-11-15",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 23,
  },
  {
    id: "vchr011",
    code: "WHOLESALE",
    description: "25% off on orders above ₹50000",
    amount: 0,
    percentage: 25,
    type: "percentage",
    maxDiscount: 15000,
    minOrderValue: 50000,
    expiryDate: "2023-12-31",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 4,
  },
  {
    id: "vchr012",
    code: "LOYALTY",
    description: "₹500 off for loyal customers",
    amount: 500,
    type: "fixed",
    minOrderValue: 3000,
    expiryDate: "2023-10-15",
    status: "ACTIVE",
    usageLimit: 0,
    usageCount: 56,
  },
];

// Dummy voucher response format
export const dummyVouchersResponse = {
  success: true,
  data: {
    vouchers: dummyVouchers,
    totalCount: dummyVouchers.length,
    page: 1,
    limit: 10,
    totalPages: Math.ceil(dummyVouchers.length / 10),
  },
};

// Dummy data for firms to be used in receipt module
export const dummyFirms = [
  {
    id: "firm001",
    firmName: "Madhur Creation",
    ownerName: "Chaitanya Goyal",
    phoneNumber: "+91 7898747967",
    gstin: "78115264569",
    address: "31, Dwarka dham colony mangliya",
    outstandingAmount: 78500,
  },
  {
    id: "firm002",
    firmName: "Fashion Hub",
    ownerName: "Rahul Sharma",
    phoneNumber: "+91 9876543210",
    gstin: "65478932145",
    address: "42, MG Road, Indore",
    outstandingAmount: 42500,
  },
  {
    id: "firm003",
    firmName: "Style Center",
    ownerName: "Priya Patel",
    phoneNumber: "+91 8765432109",
    gstin: "32145698745",
    address: "15, AB Road, Vijay Nagar, Indore",
    outstandingAmount: 65800,
  },
  {
    id: "firm004",
    firmName: "Trend Setters",
    ownerName: "Amit Kumar",
    phoneNumber: "+91 7654321098",
    gstin: "12345678901",
    address: "22, New Palasia, Indore",
    outstandingAmount: 55200,
  },
  {
    id: "firm005",
    firmName: "Men's Fashion",
    ownerName: "Rajesh Singh",
    phoneNumber: "+91 9876543211",
    gstin: "98765432101",
    address: "5, Palasia, Indore, MP",
    outstandingAmount: 38600,
  },
];

// Dummy data for outstanding bills
export const dummyOutstandingBills = {
  firm001: [
    {
      id: "bill001",
      billNumber: "INV/2023/001",
      billDate: "12/05/2023",
      totalAmount: 35000,
      pendingAmount: 18000,
    },
    {
      id: "bill002",
      billNumber: "INV/2023/005",
      billDate: "22/05/2023",
      totalAmount: 42000,
      pendingAmount: 25000,
    },
    {
      id: "bill003",
      billNumber: "INV/2023/012",
      billDate: "05/06/2023",
      totalAmount: 56000,
      pendingAmount: 35500,
    },
  ],
  firm002: [
    {
      id: "bill004",
      billNumber: "INV/2023/018",
      billDate: "15/06/2023",
      totalAmount: 27500,
      pendingAmount: 27500,
    },
    {
      id: "bill005",
      billNumber: "INV/2023/022",
      billDate: "25/06/2023",
      totalAmount: 15000,
      pendingAmount: 15000,
    },
  ],
  firm003: [
    {
      id: "bill006",
      billNumber: "INV/2023/025",
      billDate: "02/07/2023",
      totalAmount: 65800,
      pendingAmount: 65800,
    },
  ],
  firm004: [
    {
      id: "bill007",
      billNumber: "INV/2023/028",
      billDate: "08/07/2023",
      totalAmount: 32000,
      pendingAmount: 32000,
    },
    {
      id: "bill008",
      billNumber: "INV/2023/030",
      billDate: "15/07/2023",
      totalAmount: 23200,
      pendingAmount: 23200,
    },
  ],
  firm005: [
    {
      id: "bill009",
      billNumber: "INV/2023/035",
      billDate: "22/07/2023",
      totalAmount: 18600,
      pendingAmount: 18600,
    },
    {
      id: "bill010",
      billNumber: "INV/2023/042",
      billDate: "01/08/2023",
      totalAmount: 20000,
      pendingAmount: 20000,
    },
  ],
};

// Dummy data for receipts
export const dummyReceipts = [
  {
    id: "rcpt001",
    firmId: "firm001",
    firmName: "Madhur Creation",
    date: "15/07/2023",
    amount: 15000,
    paymentMode: "Cash",
    adjustedBills: ["bill001", "bill002"],
    notes: "Payment for May invoices",
  },
  {
    id: "rcpt002",
    firmId: "firm003",
    firmName: "Style Center",
    date: "18/07/2023",
    amount: 30000,
    paymentMode: "Bank",
    adjustedBills: ["bill006"],
    notes: "Partial payment via NEFT",
  },
  {
    id: "rcpt003",
    firmId: "firm002",
    firmName: "Fashion Hub",
    date: "25/07/2023",
    amount: 10000,
    paymentMode: "Cash",
    adjustedBills: ["bill004"],
    notes: "",
  },
  {
    id: "rcpt004",
    firmId: "firm004",
    firmName: "Trend Setters",
    date: "05/08/2023",
    amount: 20000,
    paymentMode: "Bank",
    adjustedBills: ["bill007"],
    notes: "Bank transfer reference: TRN123456",
  },
  {
    id: "rcpt005",
    firmId: "firm005",
    firmName: "Men's Fashion",
    date: "12/08/2023",
    amount: 18600,
    paymentMode: "Cash",
    adjustedBills: ["bill009"],
    notes: "Full settlement for July invoice",
  },
  {
    id: "rcpt006",
    firmId: "firm001",
    firmName: "Madhur Creation",
    date: "20/08/2023",
    amount: 32500,
    paymentMode: "Bank",
    adjustedBills: ["bill003"],
    notes: "UPI payment",
  },
  {
    id: "rcpt007",
    firmId: "firm003",
    firmName: "Style Center",
    date: "01/09/2023",
    amount: 35800,
    paymentMode: "Cash",
    adjustedBills: [],
    notes: "Advance payment",
  },
  {
    id: "rcpt008",
    firmId: "firm004",
    firmName: "Trend Setters",
    date: "05/09/2023",
    amount: 23200,
    paymentMode: "Bank",
    adjustedBills: ["bill008"],
    notes: "RTGS transfer",
  },
  {
    id: "rcpt009",
    firmId: "firm002",
    firmName: "Fashion Hub",
    date: "10/09/2023",
    amount: 15000,
    paymentMode: "Cash",
    adjustedBills: ["bill005"],
    notes: "Payment received by hand",
  },
  {
    id: "rcpt010",
    firmId: "firm005",
    firmName: "Men's Fashion",
    date: "15/09/2023",
    amount: 20000,
    paymentMode: "Bank",
    adjustedBills: ["bill010"],
    notes: "Online transfer",
  },
  {
    id: "rcpt011",
    firmId: "firm001",
    firmName: "Madhur Creation",
    date: "22/09/2023",
    amount: 12000,
    paymentMode: "Cash",
    adjustedBills: [],
    notes: "Partial payment",
  },
  {
    id: "rcpt012",
    firmId: "firm003",
    firmName: "Style Center",
    date: "01/10/2023",
    amount: 50000,
    paymentMode: "Bank",
    adjustedBills: [],
    notes: "Quarterly payment",
  },
];

// Dummy data for textile industry customers (Outstanding Balance)
export const dummyOutstandingBalanceData = [
  {
    id: 1,
    name: "Aditya Textiles",
    address: "123 Mill Road, Surat, GJ",
    phone: "8977666666",
    lastPayment: "12/09/2023",
    pendingAmount: 234500,
    dueDate: "30/10/2023",
    status: "Pending",
  },
  {
    id: 2,
    name: "Bombay Fabrics",
    address: "456 Textile Market, Mumbai, MH",
    phone: "9856432145",
    lastPayment: "05/09/2023",
    pendingAmount: 126750,
    dueDate: "15/10/2023",
    status: "Overdue",
  },
  {
    id: 3,
    name: "Delhi Garments",
    address: "789 Chandni Chowk, Delhi",
    phone: "7854123698",
    lastPayment: "20/09/2023",
    pendingAmount: 89250,
    dueDate: "20/10/2023",
    status: "Pending",
  },
  {
    id: 4,
    name: "Chennai Silks",
    address: "321 Textile Lane, Chennai, TN",
    phone: "9632587412",
    lastPayment: "01/09/2023",
    pendingAmount: 194340,
    dueDate: "01/10/2023",
    status: "Overdue",
  },
  {
    id: 5,
    name: "Kolkata Cottons",
    address: "654 Fabric Market, Kolkata, WB",
    phone: "8523697412",
    lastPayment: "15/09/2023",
    pendingAmount: 78950,
    dueDate: "15/10/2023",
    status: "Pending",
  },
  {
    id: 6,
    name: "Jaipur Textiles",
    address: "987 Handicraft Center, Jaipur, RJ",
    phone: "7539514628",
    lastPayment: "10/09/2023",
    pendingAmount: 45250,
    dueDate: "10/10/2023",
    status: "Cleared",
  },
];

// Dummy data for individual customer outstanding balance details
export const dummyCustomerOutstandingDetails = {
  1: {
    customerInfo: {
      name: "Aditya Textiles",
      address: "123 Mill Road, Surat, GJ",
      phone: "8977666666",
      openingBalance: 214500,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 101,
        date: "10/04/2023",
        type: "Sale",
        billNo: "INV/2023/101",
        totalAmount: 125000,
        pendingAmount: 125000,
        due: "Dr",
        dueDate: "10/05/2023",
        daysOverdue: 174,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 102,
        date: "15/05/2023",
        type: "Sale",
        billNo: "INV/2023/142",
        totalAmount: 89500,
        pendingAmount: 89500,
        due: "Dr",
        dueDate: "15/06/2023",
        daysOverdue: 138,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 103,
        date: "22/07/2023",
        type: "Payment",
        billNo: "PMT/2023/078",
        totalAmount: 50000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "22/07/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/101",
        clearDays: 103,
        adjustedAmount: 50000,
      },
      {
        id: 104,
        date: "10/08/2023",
        type: "Sale",
        billNo: "INV/2023/189",
        totalAmount: 70000,
        pendingAmount: 70000,
        due: "Dr",
        dueDate: "10/09/2023",
        daysOverdue: 51,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
    ],
    totals: {
      totalAmount: 284500,
      totalPending: 234500,
      totalPaid: 50000,
    },
  },
  2: {
    customerInfo: {
      name: "Bombay Fabrics",
      address: "456 Textile Market, Mumbai, MH",
      phone: "9856432145",
      openingBalance: 98750,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 201,
        date: "05/04/2023",
        type: "Sale",
        billNo: "INV/2023/098",
        totalAmount: 78000,
        pendingAmount: 78000,
        due: "Dr",
        dueDate: "05/05/2023",
        daysOverdue: 179,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 202,
        date: "18/06/2023",
        type: "Sale",
        billNo: "INV/2023/156",
        totalAmount: 68000,
        pendingAmount: 48750,
        due: "Dr",
        dueDate: "18/07/2023",
        daysOverdue: 105,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 203,
        date: "05/07/2023",
        type: "Payment",
        billNo: "PMT/2023/102",
        totalAmount: 50000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "05/07/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/098",
        clearDays: 91,
        adjustedAmount: 50000,
      },
      {
        id: 204,
        date: "25/08/2023",
        type: "Payment",
        billNo: "PMT/2023/145",
        totalAmount: 20000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "25/08/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/156",
        clearDays: 38,
        adjustedAmount: 20000,
      },
    ],
    totals: {
      totalAmount: 146000,
      totalPending: 126750,
      totalPaid: 70000,
    },
  },
  3: {
    customerInfo: {
      name: "Delhi Garments",
      address: "789 Chandni Chowk, Delhi",
      phone: "7854123698",
      openingBalance: 78250,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 301,
        date: "12/05/2023",
        type: "Sale",
        billNo: "INV/2023/112",
        totalAmount: 45000,
        pendingAmount: 11000,
        due: "Dr",
        dueDate: "12/06/2023",
        daysOverdue: 141,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 302,
        date: "18/07/2023",
        type: "Payment",
        billNo: "PMT/2023/089",
        totalAmount: 34000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "18/07/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/112",
        clearDays: 36,
        adjustedAmount: 34000,
      },
      {
        id: 303,
        date: "02/09/2023",
        type: "Sale",
        billNo: "INV/2023/198",
        totalAmount: 78250,
        pendingAmount: 78250,
        due: "Dr",
        dueDate: "02/10/2023",
        daysOverdue: 29,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 304,
        date: "10/09/2023",
        type: "Sale",
        billNo: "INV/2023/207",
        totalAmount: 42500,
        pendingAmount: 42500,
        due: "Dr",
        dueDate: "10/10/2023",
        daysOverdue: 21,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 305,
        date: "15/09/2023",
        type: "Payment",
        billNo: "PMT/2023/112",
        totalAmount: 25000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "15/09/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/207",
        clearDays: 0,
        adjustedAmount: 25000,
      },
      {
        id: 306,
        date: "22/09/2023",
        type: "Sale",
        billNo: "INV/2023/219",
        totalAmount: 37500,
        pendingAmount: 37500,
        due: "Dr",
        dueDate: "22/10/2023",
        daysOverdue: 9,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 307,
        date: "28/09/2023",
        type: "Sale",
        billNo: "INV/2023/225",
        totalAmount: 18000,
        pendingAmount: 18000,
        due: "Dr",
        dueDate: "28/10/2023",
        daysOverdue: 3,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 308,
        date: "05/10/2023",
        type: "Payment",
        billNo: "PMT/2023/145",
        totalAmount: 15000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "05/10/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/219",
        clearDays: 0,
        adjustedAmount: 15000,
      },
      {
        id: 309,
        date: "12/10/2023",
        type: "Sale",
        billNo: "INV/2023/241",
        totalAmount: 22500,
        pendingAmount: 22500,
        due: "Dr",
        dueDate: "12/11/2023",
        daysOverdue: 0,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 310,
        date: "15/10/2023",
        type: "Payment",
        billNo: "PMT/2023/168",
        totalAmount: 20000,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "15/10/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/225",
        clearDays: 0,
        adjustedAmount: 18000,
      },
      {
        id: 311,
        date: "20/10/2023",
        type: "Sale",
        billNo: "INV/2023/254",
        totalAmount: 15000,
        pendingAmount: 15000,
        due: "Dr",
        dueDate: "20/11/2023",
        daysOverdue: 0,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
    ],
    totals: {
      totalAmount: 259250,
      totalPending: 89250,
      totalPaid: 94000,
    },
  },
  4: {
    customerInfo: {
      name: "Chennai Silks",
      address: "321 Textile Lane, Chennai, TN",
      phone: "9632587412",
      openingBalance: 156000,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 401,
        date: "05/04/2023",
        type: "Sale",
        billNo: "INV/2023/089",
        totalAmount: 68000,
        pendingAmount: 68000,
        due: "Dr",
        dueDate: "05/05/2023",
        daysOverdue: 179,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 402,
        date: "18/04/2023",
        type: "Sale",
        billNo: "INV/2023/098",
        totalAmount: 52340,
        pendingAmount: 52340,
        due: "Dr",
        dueDate: "18/05/2023",
        daysOverdue: 166,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 403,
        date: "10/06/2023",
        type: "Sale",
        billNo: "INV/2023/145",
        totalAmount: 74000,
        pendingAmount: 74000,
        due: "Dr",
        dueDate: "10/07/2023",
        daysOverdue: 113,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
    ],
    totals: {
      totalAmount: 194340,
      totalPending: 194340,
      totalPaid: 0,
    },
  },
  5: {
    customerInfo: {
      name: "Kolkata Cottons",
      address: "654 Fabric Market, Kolkata, WB",
      phone: "8523697412",
      openingBalance: 45750,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 501,
        date: "08/06/2023",
        type: "Sale",
        billNo: "INV/2023/143",
        totalAmount: 45200,
        pendingAmount: 45200,
        due: "Dr",
        dueDate: "08/07/2023",
        daysOverdue: 115,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 502,
        date: "15/07/2023",
        type: "Sale",
        billNo: "INV/2023/165",
        totalAmount: 33750,
        pendingAmount: 33750,
        due: "Dr",
        dueDate: "15/08/2023",
        daysOverdue: 77,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
    ],
    totals: {
      totalAmount: 78950,
      totalPending: 78950,
      totalPaid: 0,
    },
  },
  6: {
    customerInfo: {
      name: "Jaipur Textiles",
      address: "987 Handicraft Center, Jaipur, RJ",
      phone: "7539514628",
      openingBalance: 58500,
      period: { from: "01/04/2023", to: "31/10/2023" },
    },
    transactions: [
      {
        id: 601,
        date: "08/04/2023",
        type: "Sale",
        billNo: "INV/2023/090",
        totalAmount: 62500,
        pendingAmount: 0,
        due: "Dr",
        dueDate: "08/05/2023",
        daysOverdue: 0,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
      {
        id: 602,
        date: "15/05/2023",
        type: "Payment",
        billNo: "PMT/2023/058",
        totalAmount: 62500,
        pendingAmount: 0,
        due: "Cr",
        dueDate: "15/05/2023",
        daysOverdue: 0,
        adjustedBy: "INV/2023/090",
        clearDays: 7,
        adjustedAmount: 62500,
      },
      {
        id: 607,
        date: "10/09/2023",
        type: "Sale",
        billNo: "INV/2023/206",
        totalAmount: 45250,
        pendingAmount: 45250,
        due: "Dr",
        dueDate: "10/10/2023",
        daysOverdue: 21,
        adjustedBy: "NA",
        clearDays: 0,
        adjustedAmount: 0,
      },
    ],
    totals: {
      totalAmount: 107750,
      totalPending: 45250,
      totalPaid: 62500,
    },
  },
};

// Dummy data for ledger transactions
export const dummyLedgerData = {
  customerInfo: {
    firmName: "Bombay Boothouse Pipariya",
    address: "31, Dwarka dham colony mangliya",
    gstin: "23AADCB2230M1ZU",
    phoneNumber: "+91 9876543210",
    period: { from: "01/04/2023", to: "07/09/2023" },
    openingBalance: 600000,
    balanceType: "Dr",
  },
  transactions: [
    {
      id: 1,
      date: "05/04/2023",
      type: "Sales",
      receiptNo: "INV/2023/001",
      txnId: "TXN10021",
      account: "Sale",
      debit: 125000,
      credit: 0,
      balance: 725000,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 2,
      date: "12/04/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/005",
      txnId: "TXN10045",
      account: "Cash",
      debit: 0,
      credit: 50000,
      balance: 675000,
      balanceType: "Dr",
      narration: "Cash payment received",
    },
    {
      id: 3,
      date: "18/04/2023",
      type: "Sales",
      receiptNo: "INV/2023/012",
      txnId: "TXN10067",
      account: "Sale",
      debit: 89500,
      credit: 0,
      balance: 764500,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 4,
      date: "25/04/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/015",
      txnId: "TXN10089",
      account: "Bank",
      debit: 0,
      credit: 75000,
      balance: 689500,
      balanceType: "Dr",
      narration: "NEFT payment",
    },
    {
      id: 5,
      date: "02/05/2023",
      type: "Sales",
      receiptNo: "INV/2023/024",
      txnId: "TXN10112",
      account: "Sale",
      debit: 54000,
      credit: 0,
      balance: 743500,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 6,
      date: "10/05/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/028",
      txnId: "TXN10134",
      account: "Cash",
      debit: 0,
      credit: 30000,
      balance: 713500,
      balanceType: "Dr",
      narration: "Cash payment received",
    },
    {
      id: 7,
      date: "22/05/2023",
      type: "Sales",
      receiptNo: "INV/2023/035",
      txnId: "TXN10156",
      account: "Sale",
      debit: 112000,
      credit: 0,
      balance: 825500,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 8,
      date: "05/06/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/042",
      txnId: "TXN10178",
      account: "Bank",
      debit: 0,
      credit: 100000,
      balance: 725500,
      balanceType: "Dr",
      narration: "RTGS payment",
    },
    {
      id: 9,
      date: "15/06/2023",
      type: "Sales",
      receiptNo: "INV/2023/050",
      txnId: "TXN10210",
      account: "Sale",
      debit: 78500,
      credit: 0,
      balance: 804000,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 10,
      date: "28/06/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/055",
      txnId: "TXN10232",
      account: "Cash",
      debit: 0,
      credit: 50000,
      balance: 754000,
      balanceType: "Dr",
      narration: "Cash payment received",
    },
    {
      id: 11,
      date: "10/07/2023",
      type: "Sales",
      receiptNo: "INV/2023/062",
      txnId: "TXN10254",
      account: "Sale",
      debit: 65000,
      credit: 0,
      balance: 819000,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 12,
      date: "22/07/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/068",
      txnId: "TXN10276",
      account: "Bank",
      debit: 0,
      credit: 65000,
      balance: 754000,
      balanceType: "Dr",
      narration: "UPI payment",
    },
    {
      id: 13,
      date: "02/08/2023",
      type: "Sales",
      receiptNo: "INV/2023/075",
      txnId: "TXN10298",
      account: "Sale",
      debit: 95000,
      credit: 0,
      balance: 849000,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 14,
      date: "15/08/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/080",
      txnId: "TXN10320",
      account: "Cash",
      debit: 0,
      credit: 75000,
      balance: 774000,
      balanceType: "Dr",
      narration: "Cash payment received",
    },
    {
      id: 15,
      date: "25/08/2023",
      type: "Sales",
      receiptNo: "INV/2023/088",
      txnId: "TXN10342",
      account: "Sale",
      debit: 120000,
      credit: 0,
      balance: 894000,
      balanceType: "Dr",
      narration: "Ready goods sales",
    },
    {
      id: 16,
      date: "05/09/2023",
      type: "Receipt",
      receiptNo: "RCT/2023/095",
      txnId: "TXN10364",
      account: "Bank",
      debit: 0,
      credit: 80000,
      balance: 814000,
      balanceType: "Dr",
      narration: "NEFT payment",
    },
  ],
  summary: {
    totalDebit: 739000,
    totalCredit: 525000,
    closingBalance: 814000,
    closingBalanceType: "Dr",
  },
};

// Dummy GST Report Data for various report types
export const dummyGSTData = {
  // Invoice-level data for GST reports
  invoiceData: [
    {
      invoiceNo: "INV/2023/135",
      date: "12/07/2023",
      firmName: "Madhur Creation",
      gstin: "23ABCDE1234F1Z5",
      taxableAmount: 28700,
      cgst: 1435,
      sgst: 1435,
      igst: 0,
      totalAmount: 31570,
    },
    {
      invoiceNo: "INV/2023/136",
      date: "15/07/2023",
      firmName: "Fashion Hub",
      gstin: "23FGHIJ5678K1Z6",
      taxableAmount: 34850,
      cgst: 0,
      sgst: 0,
      igst: 6273,
      totalAmount: 41123,
    },
    {
      invoiceNo: "INV/2023/137",
      date: "18/07/2023",
      firmName: "Style Center",
      gstin: "23KLMNO9012P1Z7",
      taxableAmount: 23575,
      cgst: 1179,
      sgst: 1179,
      igst: 0,
      totalAmount: 25933,
    },
    {
      invoiceNo: "INV/2023/138",
      date: "20/07/2023",
      firmName: "Trend Setters",
      gstin: "07QRSTU3456V1Z8",
      taxableAmount: 45264,
      cgst: 0,
      sgst: 0,
      igst: 8147,
      totalAmount: 53411,
    },
    {
      invoiceNo: "INV/2023/139",
      date: "22/07/2023",
      firmName: "Men's Fashion",
      gstin: "23WXYZ7890A1Z9",
      taxableAmount: 18925,
      cgst: 946,
      sgst: 946,
      igst: 0,
      totalAmount: 20817,
    },
    {
      invoiceNo: "INV/2023/140",
      date: "25/07/2023",
      firmName: "Ladies Corner",
      gstin: "27BCDEF1234G1Z0",
      taxableAmount: 65800,
      cgst: 0,
      sgst: 0,
      igst: 11844,
      totalAmount: 77644,
    },
    {
      invoiceNo: "INV/2023/141",
      date: "27/07/2023",
      firmName: "Kids Planet",
      gstin: "23GHIJK5678L1Z1",
      taxableAmount: 24300,
      cgst: 1215,
      sgst: 1215,
      igst: 0,
      totalAmount: 26730,
    },
    {
      invoiceNo: "INV/2023/142",
      date: "28/07/2023",
      firmName: "Sports Hub",
      gstin: "23MNOPQ9012R1Z2",
      taxableAmount: 78500,
      cgst: 3925,
      sgst: 3925,
      igst: 0,
      totalAmount: 86350,
    },
    {
      invoiceNo: "INV/2023/143",
      date: "30/07/2023",
      firmName: "Comfort Shoes",
      gstin: "06STUVW3456X1Z3",
      taxableAmount: 42500,
      cgst: 0,
      sgst: 0,
      igst: 7650,
      totalAmount: 50150,
    },
    {
      invoiceNo: "INV/2023/144",
      date: "31/07/2023",
      firmName: "Dream Creations",
      gstin: "23YZABC7890D1Z4",
      taxableAmount: 15750,
      cgst: 788,
      sgst: 788,
      igst: 0,
      totalAmount: 17326,
    },
    {
      invoiceNo: "INV/2023/145",
      date: "31/07/2023",
      firmName: "Premium Brands",
      gstin: "03EFGHI1234J1Z5",
      taxableAmount: 95000,
      cgst: 0,
      sgst: 0,
      igst: 17100,
      totalAmount: 112100,
    },
    {
      invoiceNo: "INV/2023/146",
      date: "31/07/2023",
      firmName: "Wholesale Mart",
      gstin: "23KLMNO5678P1Z6",
      taxableAmount: 120000,
      cgst: 6000,
      sgst: 6000,
      igst: 0,
      totalAmount: 132000,
    },
  ],

  // Tax Rate Summary Data
  taxRateSummary: [
    {
      taxRate: "0%",
      taxableValue: 50000,
      cgstAmount: 0,
      sgstAmount: 0,
      igstAmount: 0,
      totalTax: 0,
    },
    {
      taxRate: "5%",
      taxableValue: 160000,
      cgstAmount: 4000,
      sgstAmount: 4000,
      igstAmount: 8000,
      totalTax: 16000,
    },
    {
      taxRate: "12%",
      taxableValue: 240000,
      cgstAmount: 14400,
      sgstAmount: 14400,
      igstAmount: 28800,
      totalTax: 57600,
    },
    {
      taxRate: "18%",
      taxableValue: 320000,
      cgstAmount: 28800,
      sgstAmount: 28800,
      igstAmount: 57600,
      totalTax: 115200,
    },
    {
      taxRate: "28%",
      taxableValue: 80000,
      cgstAmount: 11200,
      sgstAmount: 11200,
      igstAmount: 22400,
      totalTax: 44800,
    },
  ],

  // Total for Tax Rate Summary
  taxRateSummaryTotal: {
    taxableValue: 850000,
    cgstAmount: 58400,
    sgstAmount: 58400,
    igstAmount: 116800,
    totalTax: 233600,
  },

  // GSTR-1 Report Data
  gstr1Data: [
    {
      gstin: "23ABCDE1234F1Z5",
      firmName: "Madhur Creation",
      invoiceNumber: "INV/2023/135",
      invoiceDate: "12/07/2023",
      invoiceValue: 31570,
      placeOfSupply: "Madhya Pradesh",
      taxRate: "5%",
      taxableValue: 28700,
    },
    {
      gstin: "23FGHIJ5678K1Z6",
      firmName: "Fashion Hub",
      invoiceNumber: "INV/2023/136",
      invoiceDate: "15/07/2023",
      invoiceValue: 41123,
      placeOfSupply: "Maharashtra",
      taxRate: "18%",
      taxableValue: 34850,
    },
    {
      gstin: "23KLMNO9012P1Z7",
      firmName: "Style Center",
      invoiceNumber: "INV/2023/137",
      invoiceDate: "18/07/2023",
      invoiceValue: 25933,
      placeOfSupply: "Madhya Pradesh",
      taxRate: "5%",
      taxableValue: 23575,
    },
    {
      gstin: "07QRSTU3456V1Z8",
      firmName: "Trend Setters",
      invoiceNumber: "INV/2023/138",
      invoiceDate: "20/07/2023",
      invoiceValue: 53411,
      placeOfSupply: "Delhi",
      taxRate: "18%",
      taxableValue: 45264,
    },
    {
      gstin: "23WXYZ7890A1Z9",
      firmName: "Men's Fashion",
      invoiceNumber: "INV/2023/139",
      invoiceDate: "22/07/2023",
      invoiceValue: 20817,
      placeOfSupply: "Madhya Pradesh",
      taxRate: "5%",
      taxableValue: 18925,
    },
  ],

  // GSTR-3B Report Data
  gstr3bData: {
    outwardSupplies: [
      {
        natureOfSupplies: "Taxable Supplies",
        taxableValue: 850000,
        integratedTax: 116800,
        centralTax: 58400,
        stateTax: 58400,
      },
      {
        natureOfSupplies: "Zero Rated Supplies",
        taxableValue: 50000,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
      },
      {
        natureOfSupplies: "Nil Rated Supplies",
        taxableValue: 25000,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
      },
      {
        natureOfSupplies: "Exempted Supplies",
        taxableValue: 15000,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
      },
      {
        natureOfSupplies: "Non-GST Supplies",
        taxableValue: 10000,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
      },
    ],
    interStateSupplies: [
      {
        placeOfSupply: "Maharashtra",
        taxableValue: 75000,
        integratedTax: 13500,
      },
      {
        placeOfSupply: "Delhi",
        taxableValue: 125000,
        integratedTax: 22500,
      },
      {
        placeOfSupply: "Gujarat",
        taxableValue: 85000,
        integratedTax: 15300,
      },
      {
        placeOfSupply: "Rajasthan",
        taxableValue: 55000,
        integratedTax: 9900,
      },
      {
        placeOfSupply: "Tamil Nadu",
        taxableValue: 45000,
        integratedTax: 8100,
      },
    ],
  },

  // HSN Summary Data
  hsnSummary: [
    {
      hsn: "6204",
      description: "Women's or girls' salwar suits and ensembles",
      uqc: "PCS",
      totalQuantity: 250,
      totalValue: 187500,
      taxableValue: 170000,
      integratedTax: 15300,
      centralTax: 7650,
      stateTax: 7650,
    },
    {
      hsn: "5407",
      description: "Synthetic fabric for salwar kameez",
      uqc: "MTR",
      totalQuantity: 500,
      totalValue: 225000,
      taxableValue: 215000,
      integratedTax: 19350,
      centralTax: 9675,
      stateTax: 9675,
    },
    {
      hsn: "5208",
      description: "Cotton fabric for salwar suits",
      uqc: "MTR",
      totalQuantity: 750,
      totalValue: 120000,
      taxableValue: 115000,
      integratedTax: 10350,
      centralTax: 5175,
      stateTax: 5175,
    },
    {
      hsn: "6117",
      description: "Dupattas and stoles",
      uqc: "PCS",
      totalQuantity: 300,
      totalValue: 93750,
      taxableValue: 90000,
      integratedTax: 8100,
      centralTax: 4050,
      stateTax: 4050,
    },
    {
      hsn: "9606",
      description: "Buttons, hooks and embellishments for suits",
      uqc: "KGS",
      totalQuantity: 100,
      totalValue: 75000,
      taxableValue: 70000,
      integratedTax: 6300,
      centralTax: 3150,
      stateTax: 3150,
    },
  ],
};

// Dummy data for user roles
export const dummyRoles = [
  {
    id: 1,
    name: "Admin",
    description: "Full access to all system features",
    permissions: [
      "show_dashboard",
      "show_product",
      "create_product",
      "edit_product",
      "delete_product",
      "download_product",
      "show_customer",
      "create_customer",
      "edit_customer",
      "show_receipts",
      "create_receipts",
      "show_role",
      "create_role",
      "edit_role",
      "delete_role",
    ],
    permissionGroups: [
      "Dashboard",
      "Products",
      "Customers",
      "Receipts",
      "User Management",
    ],
    createdAt: "2023-05-10T08:30:00.000Z",
    updatedAt: "2023-11-15T14:22:00.000Z",
  },
  {
    id: 2,
    name: "Manager",
    description: "Access to manage products and customer data",
    permissions: [
      "show_dashboard",
      "show_product",
      "create_product",
      "edit_product",
      "show_customer",
      "create_customer",
      "edit_customer",
      "show_receipts",
    ],
    permissionGroups: ["Dashboard", "Products", "Customers", "Receipts"],
    createdAt: "2023-06-20T10:15:00.000Z",
    updatedAt: "2023-10-05T09:45:00.000Z",
  },
  {
    id: 3,
    name: "Accountant",
    description: "Access to financial data and reports",
    permissions: [
      "show_dashboard",
      "show_receipts",
      "create_receipts",
      "edit_receipts",
      "show_ledger",
      "download_ledger",
      "show_gstReports",
      "download_gstReports",
      "show_outstandingBalances",
    ],
    permissionGroups: ["Dashboard", "Receipts", "Reports"],
    createdAt: "2023-07-05T14:20:00.000Z",
    updatedAt: "2023-09-18T11:30:00.000Z",
  },
  {
    id: 4,
    name: "Sales Representative",
    description: "Access to customer data and orders",
    permissions: [
      "show_dashboard",
      "show_product",
      "show_customer",
      "create_customer",
      "show_order",
      "create_order",
    ],
    permissionGroups: ["Dashboard", "Products", "Customers", "Orders"],
    createdAt: "2023-08-12T09:00:00.000Z",
    updatedAt: "2023-08-12T09:00:00.000Z",
  },
  {
    id: 5,
    name: "Inventory Manager",
    description: "Manages product inventory",
    permissions: [
      "show_dashboard",
      "show_product",
      "create_product",
      "edit_product",
      "delete_product",
      "download_product",
      "show_unit",
      "create_unit",
      "edit_unit",
    ],
    permissionGroups: ["Dashboard", "Products", "Units"],
    createdAt: "2023-09-01T11:45:00.000Z",
    updatedAt: "2023-11-10T15:20:00.000Z",
  },
];

// Dummy users data
export const dummyUsers = [
  {
    id: 1,
    name: "Rajesh Kumar",
    email: "rajesh.kumar@example.com",
    phone: "+91 98765 43210",
    role: "Admin",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-29T14:22:00.000Z",
    createdAt: "2023-01-10T08:30:00.000Z",
  },
  {
    id: 2,
    name: "Priya Sharma",
    email: "priya.sharma@example.com",
    phone: "+91 87654 32109",
    role: "Manager",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-28T10:15:00.000Z",
    createdAt: "2023-02-15T09:45:00.000Z",
  },
  {
    id: 3,
    name: "Ankit Patel",
    email: "ankit.patel@example.com",
    phone: "+91 76543 21098",
    role: "Accountant",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-27T16:30:00.000Z",
    createdAt: "2023-03-20T11:20:00.000Z",
  },
  {
    id: 4,
    name: "Sneha Gupta",
    email: "sneha.gupta@example.com",
    phone: "+91 65432 10987",
    role: "Sales Representative",
    profileImage: null,
    status: "inactive",
    lastLogin: "2023-11-15T09:10:00.000Z",
    createdAt: "2023-04-05T13:40:00.000Z",
  },
  {
    id: 5,
    name: "Vikram Singh",
    email: "vikram.singh@example.com",
    phone: "+91 54321 09876",
    role: "Inventory Manager",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-29T08:45:00.000Z",
    createdAt: "2023-05-12T10:30:00.000Z",
  },
  {
    id: 6,
    name: "Neha Verma",
    email: "neha.verma@example.com",
    phone: "+91 43210 98765",
    role: "Manager",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-28T14:20:00.000Z",
    createdAt: "2023-06-18T09:15:00.000Z",
  },
  {
    id: 7,
    name: "Arjun Reddy",
    email: "arjun.reddy@example.com",
    phone: "+91 32109 87654",
    role: "Sales Representative",
    profileImage: null,
    status: "active",
    lastLogin: "2023-11-26T11:30:00.000Z",
    createdAt: "2023-07-22T12:45:00.000Z",
  },
  {
    id: 8,
    name: "Kavita Desai",
    email: "kavita.desai@example.com",
    phone: "+91 21098 76543",
    role: "Accountant",
    profileImage: null,
    status: "inactive",
    lastLogin: "2023-11-10T15:40:00.000Z",
    createdAt: "2023-08-30T14:20:00.000Z",
  },
];

// Sample product images for ProductDetailsScreen
export const productImages = {
  prod001: [
    require("./assets/dummy/prod001a.jpg"),
    require("./assets/dummy/prod001b.jpg"),
    require("./assets/dummy/prod001c.jpg"),
    require("./assets/dummy/prod001d.jpg"),
  ],
  prod002: [
    require("./assets/dummy/prod002a.webp"),
    require("./assets/dummy/prod002b.webp"),
    require("./assets/dummy/prod002c.webp"),
    require("./assets/dummy/prod002d.webp"),
  ],
  prod003: [
    require("./assets/dummy/prod003a.webp"),
    require("./assets/dummy/prod003b.webp"),
    require("./assets/dummy/prod003c.jpg"),
    require("./assets/dummy/prod003a.webp"),
  ],
  prod004: [
    require("./assets/dummy/prod004a.webp"),
    require("./assets/dummy/prod004b.webp"),
    require("./assets/dummy/prod004c.webp"),
    require("./assets/dummy/prod004a.webp"),
  ],
  prod005: [
    require("./assets/dummy/prod005a.webp"),
    require("./assets/dummy/prod005b.webp"),
    require("./assets/dummy/prod005c.webp"),
    require("./assets/dummy/prod005d.webp"),
  ],
  prod006: [
    require("./assets/dummy/prod006a.webp"),
    require("./assets/dummy/prod006b.webp"),
    require("./assets/dummy/prod006c.webp"),
    require("./assets/dummy/prod006d.webp"),
  ],
  prod007: [
    require("./assets/dummy/prod007a.webp"),
    require("./assets/dummy/prod007b.webp"),
    require("./assets/dummy/prod007c.webp"),
    require("./assets/dummy/prod007d.webp"),
  ],
  prod008: [
    require("./assets/dummy/prod008a.jpg"),
    require("./assets/dummy/prod008b.webp"),
    require("./assets/dummy/prod008c.webp"),
    require("./assets/dummy/prod008a.jpg"),
  ],
  prod009: [
    require("./assets/dummy/prod009a.webp"),
    require("./assets/dummy/prod009b.webp"),
    require("./assets/dummy/prod009c.webp"),
    require("./assets/dummy/prod009d.webp"),
  ],
  prod010: [
    require("./assets/dummy/prod010a.jpg"),
    require("./assets/dummy/prod010b.jpg"),
    require("./assets/dummy/prod010c.jpg"),
    require("./assets/dummy/prod010a.jpg"),
  ],
  prod011: [
    require("./assets/dummy/prod005a.webp"),
    require("./assets/dummy/prod005b.webp"),
    require("./assets/dummy/prod005c.webp"),
    require("./assets/dummy/prod005d.webp"),
  ],
  prod012: [
    require("./assets/dummy/prod002a.webp"),
    require("./assets/dummy/prod002b.webp"),
    require("./assets/dummy/prod002c.webp"),
    require("./assets/dummy/prod002d.webp"),
  ],
  prod013: [
    require("./assets/dummy/prod008a.jpg"),
    require("./assets/dummy/prod008b.webp"),
    require("./assets/dummy/prod008c.webp"),
    require("./assets/dummy/prod008a.jpg"),
  ],
  prod014: [
    require("./assets/dummy/prod001a.jpg"),
    require("./assets/dummy/prod001b.jpg"),
    require("./assets/dummy/prod001c.jpg"),
    require("./assets/dummy/prod001d.jpg"),
  ],
  prod015: [
    require("./assets/dummy/prod002a.webp"),
    require("./assets/dummy/prod002b.webp"),
    require("./assets/dummy/prod002c.webp"),
    require("./assets/dummy/prod002d.webp"),
  ],
};

// Dummy notifications data
export const dummyNotifications = [
  {
    id: "notif001",
    type: "order",
    title: "New Order Received",
    message: "Order #ORD-2568 has been placed",
    isRead: false,
    timestamp: new Date(Date.now() - 1000 * 60 * 10).toISOString(), // 10 minutes ago
    link: "/orders/orderdetail/ord001",
  },
  {
    id: "notif002",
    type: "payment",
    title: "Payment Received",
    message: "Payment of ₹24,500 received from Innovative Textiles",
    isRead: false,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
    link: "/receipt/view/rcpt001",
  },
  {
    id: "notif004",
    type: "customer",
    title: "New Customer Registration",
    message: "Shanti Apparels has registered as a new customer",
    isRead: true,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), // 1 day ago
    link: "/customer/viewcustomer",
  },
  {
    id: "notif005",
    type: "request",
    title: "New Customer Request",
    message: "Suman Collection has requested addition of 5 new products",
    isRead: true,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(), // 2 days ago
    link: "/customer/request",
  },
];

// Function to format notification time
export function formatNotificationTime(timestamp) {
  const now = new Date();
  const notifTime = new Date(timestamp);
  const diffInSeconds = Math.floor((now - notifTime) / 1000);

  if (diffInSeconds < 60) {
    return "Just now";
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 172800) {
    return "Yesterday";
  } else {
    return notifTime.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
    });
  }
}

// Enhanced dummy vouchers data for ViewVoucher component
export const enhancedVouchers = {
  common: [
    {
      id: "vchr101",
      code: "DIWALI2023",
      name: "DIWALI OFFER",
      description:
        "Special discount for Diwali festive season. Enjoy extra savings on selected products.",
      discountType: "percentage",
      discountValue: 10,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Minimum order value should be ₹5000",
        "Cannot be combined with other offers",
        "Valid only on selected products",
      ],
      validFrom: "2023-10-15",
      validUntil: "2023-11-15",
      status: "active",
      isVisible: true,
      minOrderValue: 5000,
      maxDiscount: 2000,
      image: "poster.png",
      usageLimit: 0,
      usageCount: 45,
      categoryFilter: null,
    },
    {
      id: "vchr102",
      code: "WELCOME500",
      name: "WELCOME BONUS",
      description:
        "First time customer welcome discount. Get flat discount on your first purchase.",
      discountType: "fixed",
      discountValue: 500,
      adjustmentType: "Cash",
      termsAndConditions: [
        "Valid only for first time customers",
        "Minimum order value should be ₹2000",
        "One time use only",
      ],
      validFrom: "2023-09-01",
      validUntil: "2023-12-31",
      status: "active",
      isVisible: true,
      minOrderValue: 2000,
      maxDiscount: 500,
      image: "poster.png",
      usageLimit: 1,
      usageCount: 156,
      categoryFilter: null,
    },
    {
      id: "vchr103",
      code: "SUMMER15",
      name: "SUMMER SALE",
      description:
        "Beat the heat with cool discounts on summer collection. Limited time offer.",
      discountType: "percentage",
      discountValue: 15,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Applicable on summer collection only",
        "Cannot be combined with other promotions",
        "Valid for online orders only",
      ],
      validFrom: "2023-04-01",
      validUntil: "2023-06-30",
      status: "expired",
      isVisible: false,
      minOrderValue: 1500,
      maxDiscount: 1000,
      image: "poster.png",
      usageLimit: 0,
      usageCount: 278,
      categoryFilter: "Summer Collection",
    },

    {
      id: "vchr105",
      code: "FESTIVAL20",
      name: "FESTIVAL SEASON",
      description:
        "Celebrate festivals with extra savings on all products. Great time to stock up for your store.",
      discountType: "percentage",
      discountValue: 20,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Minimum order value of ₹8,000",
        "Maximum discount capped at ₹3,000",
        "Valid for wholesale customers only",
      ],
      validFrom: "2023-09-01",
      validUntil: "2024-01-15",
      status: "active",
      isVisible: true,
      minOrderValue: 8000,
      maxDiscount: 3000,
      image: "poster.png",
      usageLimit: 0,
      usageCount: 112,
      categoryFilter: null,
    },
  ],
  userSpecific: [
    {
      id: "vchr201",
      code: "VIP25OFF",
      name: "VIP CUSTOMER DISCOUNT",
      description:
        "Exclusive discount for our VIP customers. Thank you for your continued business.",
      discountType: "percentage",
      discountValue: 25,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Available only to registered VIP customers",
        "Valid on all products",
        "Cannot be combined with other offers",
      ],
      validFrom: "2023-10-01",
      validUntil: "2023-12-31",
      status: "active",
      isVisible: true,
      minOrderValue: 15000,
      maxDiscount: 5000,
      image: "poster.png",
      usageLimit: 5,
      usageCount: 2,
      userId: "user123",
      userName: "Madhur Creation",
    },
    {
      id: "vchr202",
      code: "LOYAL10",
      name: "LOYALTY BONUS",
      description:
        "Special discount for loyal customers who have been with us for over a year.",
      discountType: "percentage",
      discountValue: 10,
      adjustmentType: "Cash",
      termsAndConditions: [
        "Available to customers with 1+ year relationship",
        "No minimum order value",
        "Valid for 3 months from issue date",
      ],
      validFrom: "2023-11-01",
      validUntil: "2024-02-01",
      status: "active",
      isVisible: true,
      minOrderValue: 0,
      maxDiscount: 1000,
      image: "poster.png",
      usageLimit: 3,
      usageCount: 1,
      userId: "user456",
      userName: "Fashion Hub",
    },
    {
      id: "vchr203",
      code: "BULKORDER",
      name: "BULK ORDER DISCOUNT",
      description:
        "Special pricing for bulk orders. The more you order, the more you save.",
      discountType: "percentage",
      discountValue: 15,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Minimum order quantity of 50 pieces",
        "Valid only for wholesale orders",
        "Cannot be combined with seasonal offers",
      ],
      validFrom: "2023-09-15",
      validUntil: "2023-11-30",
      status: "active",
      isVisible: true,
      minOrderValue: 50000,
      maxDiscount: 10000,
      image: "poster.png",
      usageLimit: 2,
      usageCount: 1,
      userId: "user789",
      userName: "Trend Setters",
    },
    {
      id: "vchr204",
      code: "BIRTHDAYSP",
      name: "BIRTHDAY SPECIAL",
      description:
        "Special discount to celebrate your business anniversary with us.",
      discountType: "fixed",
      discountValue: 2000,
      adjustmentType: "Cash",
      termsAndConditions: [
        "Valid only during anniversary month",
        "Minimum purchase of ₹20,000",
        "One time use only",
      ],
      validFrom: "2023-10-10",
      validUntil: "2023-10-17",
      status: "expired",
      isVisible: false,
      minOrderValue: 20000,
      maxDiscount: 2000,
      image: "poster.png",
      usageLimit: 1,
      usageCount: 1,
      userId: "user123",
      userName: "Madhur Creation",
    },
    {
      id: "vchr205",
      code: "PARTNER15",
      name: "PREFERRED PARTNER",
      description:
        "Exclusive discount for our preferred business partners. Enjoy special savings throughout the year.",
      discountType: "percentage",
      discountValue: 15,
      adjustmentType: "Bank",
      termsAndConditions: [
        "Valid for selected business partners only",
        "Requires minimum order of ₹25,000",
        "Valid for 6 months from issue",
      ],
      validFrom: "2023-07-01",
      validUntil: "2023-12-31",
      status: "active",
      isVisible: true,
      minOrderValue: 25000,
      maxDiscount: 5000,
      image: "poster.png",
      usageLimit: 10,
      usageCount: 4,
      userId: "user321",
      userName: "Style Center",
    },
  ],
};

// Function to update voucher refetch in ViewVoucher component
export function fetchVouchers(filters = {}) {
  // This would be replaced with an actual API call in production
  // For now, return filtered dummy data based on the filters
  const { searchQuery, sortBy, status, discount } = filters;

  let commonVouchers = [...enhancedVouchers.common];
  let userVouchers = [...enhancedVouchers.userSpecific];

  // Filter by search query if provided
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    commonVouchers = commonVouchers.filter(
      voucher =>
        voucher.name.toLowerCase().includes(query) ||
        voucher.code.toLowerCase().includes(query) ||
        voucher.description.toLowerCase().includes(query),
    );

    userVouchers = userVouchers.filter(
      voucher =>
        voucher.name.toLowerCase().includes(query) ||
        voucher.code.toLowerCase().includes(query) ||
        voucher.description.toLowerCase().includes(query) ||
        voucher.userName.toLowerCase().includes(query),
    );
  }

  // Filter by status if provided
  if (status) {
    commonVouchers = commonVouchers.filter(
      voucher => voucher.status === status,
    );
    userVouchers = userVouchers.filter(voucher => voucher.status === status);
  }

  // Filter by discount range if provided
  if (discount) {
    const filterDiscount = voucher => {
      const discountVal =
        voucher.discountType === "percentage" ? voucher.discountValue : 0;

      switch (discount) {
        case "0-10":
          return discountVal >= 0 && discountVal <= 10;
        case "11-25":
          return discountVal >= 11 && discountVal <= 25;
        case "26-50":
          return discountVal >= 26 && discountVal <= 50;
        case "above-50":
          return discountVal > 50;
        default:
          return true;
      }
    };

    commonVouchers = commonVouchers.filter(filterDiscount);
    userVouchers = userVouchers.filter(filterDiscount);
  }

  // Sort vouchers if sortBy is provided
  if (sortBy) {
    const sortVouchers = vouchers => {
      return [...vouchers].sort((a, b) => {
        switch (sortBy) {
          case "newest":
            return new Date(b.validFrom) - new Date(a.validFrom);
          case "oldest":
            return new Date(a.validFrom) - new Date(b.validFrom);
          case "highest_discount":
            if (
              a.discountType === "percentage" &&
              b.discountType === "percentage"
            ) {
              return b.discountValue - a.discountValue;
            } else if (
              a.discountType === "fixed" &&
              b.discountType === "fixed"
            ) {
              return b.discountValue - a.discountValue;
            } else {
              return a.discountType === "percentage" ? 1 : -1;
            }
          case "lowest_discount":
            if (
              a.discountType === "percentage" &&
              b.discountType === "percentage"
            ) {
              return a.discountValue - b.discountValue;
            } else if (
              a.discountType === "fixed" &&
              b.discountType === "fixed"
            ) {
              return a.discountValue - b.discountValue;
            } else {
              return a.discountType === "percentage" ? -1 : 1;
            }
          default:
            return 0;
        }
      });
    };

    commonVouchers = sortVouchers(commonVouchers);
    userVouchers = sortVouchers(userVouchers);
  }

  return {
    common: commonVouchers,
    userSpecific: userVouchers,
  };
}
